<template>
  <section>
    <v-table
      url="/api/v1/agency"
      :attributes="[
        {
          attribute: 'name',
          name: 'Name'
        },
        {
          name: 'Moderatoren',
          attribute: 'moderatorsCount',
          type: 'StaticText'
        },
        {
          name: 'Bearbeiten',
          type: 'EditAgencyNameModalCell',
          sortable: false
        }
      ]"
      ref="table"
    ></v-table>
    <resource
      @persisted="refreshTable()"
      resource="agency"
      resourceName="Agentur"
      :attributes="[
        {
          name: 'name',
          label: 'Name'
        }
      ]"
    >
      <div slot="title">
        <h4>Agentur erstellen</h4>
      </div>
    </resource>
  </section>
</template>

<script lang="babel">
export default {
  mounted() {
    this.$bus.$on('resource-persisted', () => {
      this.$bus.$emit('refresh-table');
    });
  },
  destroyed () {
    this.$bus.$off('resource-persisted');
  }
};
</script>
